module.exports = __webpack_public_path__ + "static/media/regular_paper_straw_white2.c00def7c.png";